module.exports = __webpack_public_path__ + "static/media/stripe.f0f403ca.png";